import { createContext, useContext } from 'react';

export const InstrumentRowContext = createContext(null);

export const useInstrumentRowContext = () => useContext(InstrumentRowContext);

